// A senha da fila é única por grupo (o banco recusa repetida). Quando isso
// acontece, o banco devolve uma mensagem pronta para a pessoa ler — e essa
// mensagem precisa chegar à tela exatamente como veio, embaixo do campo.
// Ex.: "A senha 02 já foi cadastrada em Tupã · Masculino. Confira o número do papel."

function textoDoErro(e: unknown): string {
  if (typeof e === 'string') return e.trim();
  if (e instanceof Error) return (e.message || '').trim();
  if (typeof e === 'object' && e !== null) {
    const o = e as { message?: unknown; details?: unknown; hint?: unknown };
    const msg = typeof o.message === 'string' ? o.message : '';
    if (msg.trim()) return msg.trim();
    const det = typeof o.details === 'string' ? o.details : '';
    if (det.trim()) return det.trim();
    const hint = typeof o.hint === 'string' ? o.hint : '';
    if (hint.trim()) return hint.trim();
  }
  return '';
}

function semAcento(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

// Devolve a mensagem do banco quando o erro é de senha já cadastrada.
// Caso não seja, devolve null (aí a tela segue com o tratamento normal).
export function mensagemSenhaRepetida(e: unknown): string | null {
  const msg = textoDoErro(e);
  if (!msg) return null;
  const m = semAcento(msg);
  if (!m.includes('senha')) return null;
  const ehRepetida =
    m.includes('cadastrad') ||
    m.includes('repetid') ||
    m.includes('ja existe') ||
    m.includes('ja foi usada') ||
    m.includes('duplicad');
  return ehRepetida ? msg : null;
}